import axios from "axios";
import Vue from 'vue';
const state = {
    tournaments: {}, // {parentTournamentId: {subTournamentId: tournament_data}...}
    isParticipant: false,
    isCheckedIn: false,
    tournamentsLoaded: false,
    participations: [],
    checkIns: [],
    participationsByTeam: {}, //{tournamentId: teamId, ....}
    selectedTournament: null,
}


const actions = {
    initTournaments({commit}){
        const tournamentsIds = {
            "eafc25":[
                process.env.VUE_APP_TOURNAMENT_EAFC25_QUALI1_ID,
                process.env.VUE_APP_TOURNAMENT_EAFC25_QUALI2_ID,
                process.env.VUE_APP_TOURNAMENT_EAFC25_QUALI3_ID,
            ],
            "free-fire":[
                process.env.VUE_APP_TOURNAMENT_FREEFIRE_QUALI1_ID,
                process.env.VUE_APP_TOURNAMENT_FREEFIRE_QUALI2_ID,
                process.env.VUE_APP_TOURNAMENT_FREEFIRE_QUALI3_ID,
            ],
            "valorant":[
                process.env.VUE_APP_TOURNAMENT_VALO_QUALI1_ID,
                process.env.VUE_APP_TOURNAMENT_VALO_QUALI2_ID,
                process.env.VUE_APP_TOURNAMENT_VALO_QUALI3_ID,
            ],
            "street-fighter":[
                process.env.VUE_APP_TOURNAMENT_STREETFIGHTER_QUALI1_ID,
                process.env.VUE_APP_TOURNAMENT_STREETFIGHTER_QUALI2_ID,
                process.env.VUE_APP_TOURNAMENT_STREETFIGHTER_QUALI3_ID,
            ]
        }
        // fetching tournaments
        let fetches = []
        for(const [game, tournamentIds] of Object.entries(tournamentsIds)){
            fetches = tournamentIds.map(tournamentId => {
                return axios.get('tournaments/'+tournamentId)
                    .then(response => {
                        commit('addTournament', {
                            game,
                            data:response.data.data});
                    })
                    .catch(error => {
                        console.error(`Error fetching ${game} tournament (${tournamentId}):`, error);
                        return { tournamentId, data: null }; // still return something

                    })
            })
        }
       return Promise.all(fetches).finally(()=>{
            commit('tournamentsLoaded', true);
        });
        //console.log("data fetched for game: ", game , results);
    },
    checkParticipation({commit,state}, payload){
        const {playerId, gameId, playModeSize, tournamentId} = payload;
        return axios.post('user/player/participant-in', {
            tournament_id: tournamentId,
            player_id: playerId,
            //participant_type: state.tournamentItem.settings.play_mode.size > 1 ? 'team' : 'player',
            participant_type: playModeSize > 1 ? 'team' : 'player',
            game_id: gameId
        }).then(res => {
            if(res?.data?.success === true){
                commit('setParticipation', {
                    isParticipant: res.data.isParticipant,
                    isCheckedIn: res.data.isCheckedIn,
                    tournamentId: tournamentId,
                    gameName: payload.gameName,
                });
                if(state.tournaments[payload.gameName][tournamentId].settings.play_mode.size > 1){
                    commit('setTeamParticipation', {
                        ...res.data,
                        tournamentId: tournamentId,
                        gameName: payload.gameName,
                    });
                }

            }
        })
    },
    registerParticipantIn({commit}, payload){
        const {tournamentId, playerId, gameName} = payload;
        return axios.post('user/tournament/'+tournamentId+'/participant/participate',{
            participant_id: playerId,
            participant_type: 'Player',
            custom_fields: payload?.customFieldsValue
        })
            .then(response => {
                if(response.data.success){
                    commit('setPlayerIsParticipant', {
                        data:  response.data.data,
                        tournamentId: tournamentId,
                        gameName: gameName,
                    });
                }
            })
            .catch(error => {
                console.log('===================================== catch error message START =========================')
                console.log(error)
                console.log('===================================== catch error message END =========================')
            });
    }
    ,
    cancelParticipation({commit}, payload){
        const {playerId, tournamentId, gameName} = payload;
        return axios.post('user/tournament/'+tournamentId+'/participant/remove', {
            participant_id: playerId,
            participant_type: 'player',
        })
            .then(response => {
                if(response.data.success){
                    commit('cancelParticipation', {
                        data:response.data.data,
                        tournamentId: tournamentId,
                        gameName: gameName,
                    });
                }
            })
    },
    registerTeamIn({commit}, payload){
        console.log("registerTeamIn: ", payload)
        const {teamId, tournamentId, gameName} = payload;
        return axios.post('user/tournament/'+tournamentId+'/participant/participate', {
            participant_id: teamId,
            participant_type: 'team',
            custom_fields: payload.customFieldsValue,
        })
            .then(response => {
                if(response.data.success){
                    console.log('========================================== team participation log ================================')
                    console.log(response.data)
                    console.log('========================================== team participation log ================================')
                    commit('setTeamIsParticipant', {
                        participants: response.data.data,
                        participantTeamId: teamId,
                        gameName: gameName,
                        tournamentId: tournamentId,
                    });
                }
            })
            .catch(error => {
                console.log(error.response)
            })

    },
    cancelTeamParticipation({commit}, payload){
        console.log("cancelTeamParticipation: ", payload)
        const {teamId, tournamentId, gameName} = payload;
        return axios.post('user/tournament/'+tournamentId+'/participant/remove', {
            participant_id: teamId,
            participant_type: 'Team',
        }).then(response => {
            commit('cancelTeamParticipation', {
                data: response.data.data,
                tournamentId: tournamentId,
                gameName: gameName,
            });
        }).catch(error => {
            console.log(error);
        })
    },
    setSelectedTournament({commit}, payload){
        return commit('setSelectedTournament', payload);
    }
}
const mutations = {
    addTournament(state, payload) {
        const { game, data } = payload;

        if (!state.tournaments[game]) {
            Vue.set(state.tournaments, game, {});
        }

        if (data) {
            Vue.set(state.tournaments[game], data.id, {
                ...data,
                isParticipant: false,
                isCheckedIn: false
            });
        }
    },
    setParticipation(state, payload) {
        console.log("set participation: ", payload.gameName, payload.tournamentId, " isParticipant: ", payload.isParticipant, " isCheckedIn: ", payload.isCheckedIn, "")
        //state.tournaments[payload.gameName][payload.tournamentId].isParticipant = payload.isParticipant;
       // state.tournaments[payload.gameName][payload.tournamentId].isCheckedIn = payload.isCheckedIn;
        const tournament = state.tournaments[payload.gameName][payload.tournamentId];
        if (tournament) {
            Vue.set(tournament, 'isParticipant', payload.isParticipant);
            Vue.set(tournament, 'isCheckedIn', payload.isCheckedIn);
        }
        if (payload.isParticipant && !state.participations.includes(payload.tournamentId)) {
            state.participations.push(payload.tournamentId);
        }
    },
    setTeamParticipation(state, payload) {
      Vue.set(state.participationsByTeam, payload.tournamentId, payload.team_id);
    },
    tournamentsLoaded(state, isLoaded) {
        console.log("tournamentsLoaded: ", isLoaded)
        state.tournamentsLoaded = isLoaded;
    },
    setPlayerIsParticipant(state, payload) {
        const {data, tournamentId, gameName} = payload;
        state.participations.push(payload.tournamentId);
        const t = state.tournaments[gameName][tournamentId];
        Vue.set(t, 'participants_players', data);
        Vue.set(t, 'isParticipant', true);
    },
    cancelParticipation(state, payload){
        const {data, tournamentId, gameName} = payload;
        state.tournaments[gameName][tournamentId].participants_players = data;
        const t = state.tournaments[gameName][tournamentId];
        Vue.set(t, 'participants_players', data);
        Vue.set(t, 'isParticipant', false);
        const indexParticipation = state.participations.indexOf(tournamentId);
        if(indexParticipation > -1){
            state.participations.splice(indexParticipation, 1);
        }
        const indexCheckIn = state.participations.indexOf(tournamentId);
        if(indexCheckIn > -1){
            state.participations.splice(indexCheckIn, 1);
        }
    },
    setTeamIsParticipant(state, payload){
        const {participants, tournamentId, gameName} = payload;
        state.participations.push(payload.tournamentId);
        /*state.participationsByTeam[payload.tournamentId] = payload.participantTeamId;
        state.tournaments[gameName][tournamentId].participants_teams = participants;
        state.tournaments[gameName][tournamentId].isParticipant = true;*/

        Vue.set(state.participationsByTeam, tournamentId, payload.participantTeamId);
        const t = state.tournaments[gameName][payload.tournamentId];
        Vue.set(t, 'participants_teams', participants);
        Vue.set(t, 'isParticipant', true);
    },
    cancelTeamParticipation(state, payload){
        const {data, tournamentId, gameName} = payload;


        const t = state.tournaments[payload.gameName][payload.tournamentId];
        Vue.set(t, 'participants_teams', data);
        const indexParticipation = state.participations.indexOf(tournamentId);
        if(state.participationsByTeam[tournamentId]){
            Vue.delete(state.participationsByTeam, tournamentId);
        }
        if(indexParticipation > -1){
            state.participations.splice(indexParticipation, 1);
        }
        const indexCheckIn = state.participations.indexOf(tournamentId);
        if(indexCheckIn > -1){
            state.participations.splice(indexCheckIn, 1);
        }
    },
    setSelectedTournament(state, payload){
        state.selectedTournament = Object.assign({},
            state.tournaments[payload.gameName][payload.tournamentId]
        );
    }
}
const getters={
    isParticipantInTournament: (state) => (tournamentId) => {
        return state.participations.includes(tournamentId);
    },
    getTournament: (state) => (tournamentId, game) => {
        if(state.tournaments[game][tournamentId]){
            return state.tournaments[game][tournamentId];
        }
        return {}

    },
    getSelectedTournament: (state) => {
        return state.selectedTournament;
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}

